import { render, staticRenderFns } from "./GenderPicker.vue?vue&type=template&id=3f3f66f2&scoped=true"
import script from "./GenderPicker.vue?vue&type=script&lang=js"
export * from "./GenderPicker.vue?vue&type=script&lang=js"
import style0 from "./GenderPicker.vue?vue&type=style&index=0&id=3f3f66f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3f66f2",
  null
  
)

export default component.exports